import useCountDown from '@/features/UseCountdown/UseCountdown';
import { Typography } from '@/shared/ui';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TournamentStartCountdown.module.scss';

interface CountDownProps {
	initialTimeSeconds: number;
}

const TournamentStartCountdown = ({ initialTimeSeconds }: CountDownProps) => {
	const countdownStartTimeRef = useRef(Date.now());

	const { displayTime: countdown } = useCountDown({
		initTimeSeconds: initialTimeSeconds,
		start: initialTimeSeconds !== 0,
		startTime: countdownStartTimeRef.current,
	});

	const { t } = useTranslation('translation', { keyPrefix: 'tournament' });

	return (
		<div className={styles.countdown}>
			<Typography variant='caption2' color='white'>
				{t('beforeStart')}
			</Typography>
			<Typography variant='headline1' color='white'>
				{countdown}
			</Typography>
		</div>
	);
};

export default TournamentStartCountdown;
